module.exports = __webpack_public_path__ + "img/DCHQ-dark.c11e1351.svg";